import { companyInfo } from '@/mocks/homeData';

export default function CompanyIntro() {
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="section-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <div className="animate-on-scroll">
            <div className="relative">
              <img
                src="/images/fa1.jpg"
                alt="BA Fashionwear factory exterior"
                className="w-full rounded-lg object-cover aspect-[4/3]"
              />
              <div className="absolute -bottom-5 -right-5 bg-primary-500 text-white px-6 py-4 rounded-lg hidden md:block">
                <div className="text-2xl font-heading font-bold"> {new Date().getFullYear() - 2021}+</div>
                <div className="text-xs text-white/80">Years of Excellence</div>
              </div>
            </div>
          </div>

          <div className="animate-on-scroll animate-on-scroll-delay-2">
            <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-6">
              About BA Fashionwear
            </div>

            <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-4 leading-tight">
              A Legacy of Manufacturing<br />Excellence in Bangladesh
            </h2>

            <p className="text-foreground-600 leading-relaxed mb-5">
              {companyInfo.description}
            </p>
            <p className="text-foreground-600 leading-relaxed mb-8">
              As the dedicated manufacturing facility of <strong className="text-foreground-800">Beaumonde Tex Ltd.</strong>, BA Fashionwear combines deep industry expertise with state-of-the-art infrastructure. Our vertically integrated operations, skilled workforce of 1,200+ professionals, and commitment to international standards make us the preferred partner for leading global brands.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {companyInfo.values.slice(0, 4).map((val, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex-shrink-0 rounded-full bg-primary-50 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-500 text-sm"></i>
                  </div>
                  <div>
                    <div className="text-sm font-heading font-semibold text-foreground-800 mb-0.5">{val.title}</div>
                    <div className="text-xs text-foreground-500 leading-relaxed">{val.description}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-6 pt-4 border-t border-[#E6EAF0]">
              <div>
                <div className="text-xs text-foreground-400 uppercase tracking-wide">Parent Company</div>
                <div className="text-sm font-heading font-semibold text-foreground-800">{companyInfo.parentCompany}</div>
              </div>
              <div className="w-px h-8 bg-[#E6EAF0]"></div>
              <div>
                <div className="text-xs text-foreground-400 uppercase tracking-wide">Established</div>
                <div className="text-sm font-heading font-semibold text-foreground-800">{companyInfo.established}</div>
              </div>
              <div className="w-px h-8 bg-[#E6EAF0]"></div>
              <div>
                <div className="text-xs text-foreground-400 uppercase tracking-wide">Location</div>
                <div className="text-sm font-heading font-semibold text-foreground-800">{companyInfo.location}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}